
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 18V6C2 4.89543 2.89543 4 4 4H8.5L10.5 6H19.5C20.6046 6 21.5 6.89543 21.5 8V18C21.5 19.1046 20.6046 20 19.5 20H4C2.89543 20 2 19.1046 2 18Z","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6 10L2.96562 18.6697C2.73806 19.3198 3.22063 20 3.90948 20H19.256C19.6976 20 20.0869 19.7103 20.2138 19.2873L23 10H6Z","fill":"#F7F7F7","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"18","cy":"18","r":"5","fill":"#F7F7F7","stroke":"#262D33","stroke-width":"2"}}),_c('path',{attrs:{"d":"M18 16V20.5M18 20.5L16 19M18 20.5L20 19","stroke":"#262D33","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    